
    import { mapState, mapMutations } from 'vuex';

    export default {
        name: 'AuthEmailDebounce',

        props: {
            user: {
                type: Object,
                default: () => { return {}; },
            },
        },

        computed: {
            ...mapState({
                $_emailDebounce: state => state.auth.emailDebounce,
            }),

            isEmailSuggested() {
                return this.$_emailDebounce.is_invalid && this.$_emailDebounce.did_you_mean;
            },

            isEmailInvalid() {
                return this.$_emailDebounce.is_validated && this.$_emailDebounce.is_invalid;
            },

            isEmailForced() {
                return this.$_emailDebounce.is_forced;
            },

            isEmailValidated() {
                return this.$_emailDebounce.is_validated;
            },

            isNewUser() {
                return this.user && this.user.email && (typeof this.user.id === 'undefined' || typeof this.user.password_expired === 'undefined');
            },
        },

        methods: {
            ...mapMutations('auth', {
                $_SET_EMAIL_DEBOUNCE: 'SET_EMAIL_DEBOUNCE',
            }),

            forceEmail() {
                this.$_SET_EMAIL_DEBOUNCE({
                    key: 'is_validated',
                    value: true,
                });
                this.$_SET_EMAIL_DEBOUNCE({
                    key: 'is_forced',
                    value: true,
                });
                this.$emit('forceEmail');
            },

            useSuggestedEmail() {
                this.$emit('useSuggestedEmail', this.$_emailDebounce.did_you_mean);
                this.forceEmail();
            },
        },
    };
